import { ScreenQuestionProps, NumericAnswerRange } from './types';
import { SalaryRange } from '../../models/UserModels';

const BASE_EXPECTED_SALARY_QUESTION: ScreenQuestionProps = {
  title: 'Expected Salary',
  question: 'What is your expected take-home salary?',
  type: 'SalaryRange',
  category: 'PreDefined',
  answerType: 'numeric',
};

const sanitizeNumeric = (value?: number | null): number | undefined => {
  if (typeof value !== 'number') return undefined;
  if (Number.isNaN(value)) return undefined;
  if (value <= 0) return undefined;
  return value;
};

export const createExpectedSalaryQuestion = (
  overrides: Partial<ScreenQuestionProps> = {},
): ScreenQuestionProps => ({
  ...BASE_EXPECTED_SALARY_QUESTION,
  required: false,
  ...overrides,
});

export const EXPECTED_SALARY_PREDEFINED_QUESTION: ScreenQuestionProps = {
  ...BASE_EXPECTED_SALARY_QUESTION,
  required: true,
};

export const salaryRangeFromAnswer = (
  answer?: NumericAnswerRange | null,
): SalaryRange | undefined => {
  if (!answer) return undefined;
  const min = sanitizeNumeric(answer.min);
  const max = sanitizeNumeric(answer.max);

  if (min === undefined && max === undefined) {
    return undefined;
  }

  return {
    type: answer.unit ?? 'Month',
    currency: answer.currency ?? '1',
    fromAmount: min,
    amount: max ?? 0,
  };
};

export const answerFromSalaryRange = (
  value?: SalaryRange | null,
): NumericAnswerRange | undefined => {
  if (!value) return undefined;
  const min = sanitizeNumeric(value.fromAmount ?? undefined);
  const max = sanitizeNumeric(value.amount ?? undefined);

  if (min === undefined && max === undefined) {
    return undefined;
  }

  return {
    min,
    max,
    unit: value.type,
    currency: value.currency,
  };
};
